import React from "react";
import PropTypes from 'prop-types';

import {
  Modal
} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from "../../../locale/jsonMessages";
//Styles
import withStyles from "isomorphic-style-loader/withStyles";
import s from './FilterModal.css';
import cx from 'classnames'
//Redux
import { connect } from "react-redux";
//action
import { closeFilterModal } from "../../../actions/modalActions";
import { onChangeListingFilter } from '../../../actions/Listing/onChangeListing';
//components
import FilterListing from "./FilterListing";

class FilterModal extends React.Component {
  static propTypes = {
    closeFilterModal: PropTypes.any.isRequired,
    type: PropTypes.string.isRequired,
    filterModal: PropTypes.bool,
    searchKey: PropTypes.string.isRequired,
    listId: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    orderBy: PropTypes.string.isRequired,
    setStateVariable: PropTypes.func,
    refetch: PropTypes.any.isRequired,
  };

  static defaultProps = {
    filterModal: false
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { refetch, listId, orderBy, startDate, endDate, setStateVariable } = this.props;
    let variables = { listId, orderBy, startDate, endDate, currentPage: 1 };
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      setStateVariable(variables)
      refetch(variables)
    }
  }

  handleHideModal = async () => {
    const { refetch, listId, orderBy, startDate, endDate, setStateVariable, closeFilterModal } = this.props;
    let variables = { listId: Number(listId), orderBy, startDate, endDate, currentPage: 1 };
    setStateVariable(variables);
    refetch(variables);
    closeFilterModal();
  }

  render() {
    const { closeFilterModal, filterModal, refetch, type, setStateVariable } = this.props;
    return (
      <Modal show={filterModal} animation={false} onHide={this.handleHideModal}
        dialogClassName='commonModalContainer globalModalContainer'>
        <div ref={this.setWrapperRef}>
          <Modal.Header closeButton className='commonModalHeader'>
            <Modal.Title className='commonModalTitle'><FormattedMessage {...messages.filters} /></Modal.Title>
          </Modal.Header>
          <Modal.Body bsClass='commonModalBody'>
            <FilterListing refetch={refetch} type={type} setStateVariable={setStateVariable} />
          </Modal.Body>
        </div>
      </Modal>
    );
  }
}

const mapState = (state) => ({
  filterModal: state.modalStatus.filterModal,
  listId: state.onChangeListing?.listId,
  orderBy: state.onChangeListing?.orderBy,
  startDate: state.onChangeListing?.startDate,
  endDate: state.onChangeListing?.endDate,
});

const mapDispatch = {
  closeFilterModal,
  onChangeListingFilter
}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(FilterModal)));